<ng-container *tuiLet="SearchPanelVisibility$ | async as searchPanelVisibility">
    @if (searchPanelVisibility) {
        @defer (on viewport) {
        <app-dates-and-accupancy (closed)="closeSearchPanel()"></app-dates-and-accupancy>
        }
        @placeholder {
            <tui-loader [showLoader]="true" style="height: 133px;"></tui-loader>
        }
    }
    @else {
        <a (click)="close()" class="btnCloseMobile">
            <tui-icon icon="@tui.x"></tui-icon>
        </a>
        <div class="w-title">
            <span>{{'pricechecker'|translate}}</span>
        </div>
        @if ((selectDatesAndAccupancyResult$|async) != null) {
            <a (click)="minimize()" class="btnClose">
                <tui-icon icon="@tui.x"></tui-icon>
            </a>
            <div class="location-and-device">
                <div class="label">
                    {{'votrerechercheactuelle'|translate}}
                </div>
                <div class="values">
                    <span>{{selectClientCountry$|async}}</span>
                    <span class="divider"></span>
                    @if (!!(selectIsMobile$|async) == true) {
                        <span>{{'mobile'|translate}}</span>
                    }
                    @else {
                        <span>{{'pc'|translate}}</span>
                    }
                </div>
            </div>
        }
        <div class="dates text-center relative" *tuiLet="selectDatesAndAccupancyResult$|async as datesAndAccupancyResult">
            <tui-loader [showLoader]="!!(selectHotelBookingLoader$ |async)" [overlay]="true">
                
                @if (datesAndAccupancyResult == null) {
                    <div class="search-trigger">
                        <tui-icon icon="/assets/svg/calendar2.svg"></tui-icon>
                        <textarea
                            placeholder="{{'choisirdesdates'|translate}}"
                            tuiTextarea
                            (focus)="dateRangeFocusChanged(true)"
                        ></textarea>
                    </div>
                }
                @else {
                    
                    <div class="result" (click)="dateRangeFocusChanged(true)">
                        <div class="fromTo">
                            <tui-icon icon="/assets/svg/calendar.svg" class="ok"></tui-icon>
                            <div>
                                <span>
                                    {{'from'|translate}} <span class="value">{{datesAndAccupancyResult.from}}</span>
                                </span>
                                <span>
                                    {{'au'|translate}} <span class="value">{{datesAndAccupancyResult.to}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="occupancy">
                            <span>
                                <tui-icon icon="/assets/svg/adultes.svg"></tui-icon>
                                <span class="value">{{datesAndAccupancyResult.adultes}}</span>
                            </span>
                            @if (datesAndAccupancyResult.children) {
                                <span 
                                    class="d-flex flex-column"
                                    [tuiHint]="datesAndAccupancyResult.ages"
                                    tuiHintDescribe
	                                tuiHintDirection="top"
                                >
                                    <span>
                                        <tui-icon icon="/assets/svg/child.svg"></tui-icon>
                                        <span class="value">{{datesAndAccupancyResult.children}}</span>
                                    </span>
                                </span>
                            }
                        </div>
                        @if (datesAndAccupancyResult.rooms) {
                            <div class="rooms">
                                <tui-icon icon="/assets/svg/room.svg"></tui-icon>
                                <span class="value">{{datesAndAccupancyResult.rooms}}</span>
                            </div>
                        }
                    </div>
                }
            </tui-loader>
        </div>
        <div class="dispo" *tuiLet="selectBestPrice$ |async as bestPrice">
            @if (bestPrice != null) {
                <!-- block price web site officiel -->
                <div class="min-price" *tuiLet="selectDatesAndAccupancy$|async as datesAndAccupancy">
                    <span class="prix d-flex flex-column internet">
                        <div class="price-official">
                            <div class="d-flex align-items-center">
                                <tui-icon icon="/assets/svg/ratematch.svg"></tui-icon>
                                <span class="text">
                                    <b class="d-inline-block">{{'bookdirect'|translate}}</b>
                                </span>
                            </div>
                        </div>
                        <div class="book-direct">
                            <div class="book-direct-room">
                                <img [src]="getImage(bestPrice.code_room)|async" alt="">
                                <div class="d-flex mt-1 flex-column">
                                        <label *tuiLet="getRoomName(bestPrice.code_room)|async as roomName" title="{{roomName}}">{{roomName}}</label>
                                        <span *ngIf="selectBestPriceMealPLan$|async as mealPLan">
                                            {{mealPLan.name | removeWhitespace | customTranslate:mealPLan.values }}
                                        </span>
                                </div>
                                <span>
                                    @let annulationShortTranslation = getAnnulationShortTranslation($any(bestPrice.conditiondetail).annulation, $any(datesAndAccupancy).range.from);

                                    {{annulationShortTranslation.codemot|customTranslate:annulationShortTranslation.params}}
                                </span>
                            </div>
                            <div class="book-direct-price">
                                <div class="price-wrapper">
                                    <div class="d-flex justify-content-between align-items-end flex-column">
                                        <app-occupancy-info [bestPrice]="bestPrice" [datesAndAccupancy]="$any(datesAndAccupancy)"></app-occupancy-info>
                                        <b class="d-inline-blick">
                                            {{'apartirde'|translate}}
                                        </b>
                                        <b class="d-flex align-items-center">
                                            <strong class="price">{{bestPrice.detailPrice.Ttc|currencyExchange:bestPrice.currency:$any(datesAndAccupancy?.currency) |async }}</strong>
                                        </b>
                                    </div>
                                </div>
                                @if ((selectWHasBook$|async)==true) {
                                    <ng-container *tuiLet="selectBookingLink$|async as link">
                                            <a [href]="bookingButton()==true? `${link?.[0]}&index=${bestPrice.indexSearch}` : `${link?.[1]}&index=${bestPrice.indexSearch}`" target="_blank" class="btn btn-checkdispo widget-iqscan-btn-reserve-2 d-inline-block">
                                               {{'reservezmaintenant'|translate}}
                                            </a>
                                    </ng-container>
                                }
                            </div>
                        </div>
                        @let engineOptions = (selectEngineOptions|async);
                        @if( engineOptions && engineOptions.length>1 ){
                            <div class="check-options" *tuiLet="selectBookingLink$|async as link">
                                <a [href]="bookingButton()==true? link?.[0] : link?.[1]" target="_blank" class="btn btn-checkdispo mt-2">
                                    {{'voirlesoptions'|translate}}
                                </a>
                            </div>
                        }
                    </span>
                </div>
                <!-- block price all engines -->
                <router-outlet></router-outlet>
            }
        </div>
        @if ((onFailed$|async) == true) {
            <div class="soldOut" *tuiLet="selectDatesAndAccupancy$|async as dates">
                <div class="alert">
                    <tui-icon icon="@tui.info"></tui-icon>
                    <p class="message">{{'desolesnousnedisposonsdaucunedisponibiliteentrele$x1etle$x2'| customTranslate: {val1: dates?.range?.from?.getFormattedDay('DMY','/') , val2: dates?.range?.to?.getFormattedDay('DMY','/')} }}</p>
                </div>
                <ng-container *tuiLet="selectProposition$ |async as propositions">
                    @if ( propositions?.length || !!(selectPropositionLoader$ |async) ) {
                        <div class="proposition">
                            <p>
                                {{'thesedatesarestillavailable,butmaysellout' | translate }} :
                            </p>
                            <div class="scroll-content">
                                <div class="holder-dates">
                                    @if (!!(selectPropositionLoader$ |async)) {
                                        <div class="load"></div>
                                    }
                                    @for (prop of propositions; track $index) {
                                        <div class="date" (click)="resend(prop, dates)">
                                            <span> {{moment(prop.startDate).format('DD MMM')}} - {{moment(prop.endDate).format('DD MMM')}} </span>
                                            <small>{{prop.nights}} {{'nuits'| translate}}</small>
                                            <strong>{{'des'| translate}} {{prop.price.amount}} {{ prop.price.currency| tuiCurrency }}</strong>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </ng-container>
            </div>
        }
    }
</ng-container>